<template>
  <cTable :fields="fields" :header="header" :methods="methods" :modals="modals" :footer="footer" :config="config"
    ref="table">
    <template #header_bottom>
      <span style="margin-right: 10px;margin-bottom: 10px;" v-for="(item, key) in render()" :key="key">
        {{ item.name }}:
        <span style="color: #0055ff;">{{ item.value }}</span>
      </span>
    </template>
  </cTable>
</template>

<script>
import {
  getList,
  add,
  detail,
  update,
  del,
} from "@/api/finance/halfPrice";

import cTable from "@/base/common/index";
import { getAllClient } from "@/api/user/client";
import { getCountry } from "@/api/system/country";

export default {
  components: {
    cTable
  },
  props: ['rows', 'selectData', 'infoFields'],
  mounted() {
    this.header.searchs.forEach(async item => {
      if (item.key === "client_id")
        item.options = (await getAllClient()).data.payload.rows;
      if (item.key === "from_country")
        item.options = (
          await getCountry({ allow_depart: 1 })
        ).data.payload.rows;
      if (item.key === "to_country")
        item.options = (
          await getCountry({ allow_arrive: 1 })
        ).data.payload.rows;
    });
  },
  methods: {
    render() {
      return ['clientInfo.client_account', 'from_country', 'to_country', 'collection_method_txt', 'time_type_txt', 'data_type_txt'].map(t => {
        let field = this.infoFields.find(item => item.key === t)
        let name = field.name()
        return {
          name,
          value: (t.includes('clientInfo') ? this.rows['clientInfo'][t.split('.')[1]] : this.rows[t])
        }
      })
    }
  },
  data() {
    let collection_method = [
      {
        label: this.$t("freeShipping"),
        value: 0
      },
      {
        label: this.$t("fixedAmount"),
        value: 2
      }
    ]
    return {
      methods: {
        list: () => {
          return getList({ config_id: this.rows.id })
        },
        getList,
        add,
        detail,
        update,
        del,
      },
      config: {
        slot: "div",
        rows: this.rows
      },
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              let type = "add";
              if (row.id) {
                type = "update";
              }
              this.$page.handleRequestMethods(type, row).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page.getList();
                close();
              });
            }
          },
          config: {
            title: this.$t("add"),
            modalBind: {
              width: 800,
              draggable: true
            },
            formBind: {
              labelWidth: 120
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              collection_method: [{ required: true, type: "number", message: "cannot be empty", trigger: "blur" }],
              every_amount: [{ required: true, type: "number", message: "cannot be empty", trigger: "blur" }],
              every_amount_currency: [{ required: true, message: "cannot be empty", trigger: "blur" }],
              freight_rate: [{ required: true, type: "number", message: "cannot be empty", trigger: "blur" }],
              start_day: [{ required: true, type: "date", message: "cannot be empty", trigger: "blur" }],
              end_day: [{ required: true, type: "date", message: "cannot be empty", trigger: "blur" }],
            }
          },
          grid: [
            { lower_threshold: 24 },
            { upper_threshold: 24 },
            { every_amount: 24 },
            { every_amount_currency: 24 },
            { freight_rate: 24 },
            { fee_vat_scale: 24 },
            { start_day: 24 },
            { end_day: 24 },
            { remarks: 24 }
          ],
          fields: [

            {
              name: () => this.$t("Fixed amount currency per ticket"),
              key: "every_amount_currency",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("Fixed amount currency per ticket"),
              options: this.selectData.currency,
              config: {
                label: "code",
                value: "code"
              },
              show: ({ row }) => this.rows.collection_method == 2
            },
            {
              name: () => this.$t("Fixed amount per ticket"),
              key: "every_amount",
              component: "InputNumber",
              bind: {
                style: {
                  width: "100%"
                }
              },
              default: 0,
              show: ({ row }) => this.rows.collection_method == 2
            },
            {
              name: () => this.$tz("计费重,最小值"),
              key: "lower_threshold",
              component: "InputNumber",
              bind: {
                style: {
                  width: "100%"
                }
              },
              default: 0,
              show: ({ row }) => this.rows.data_type != 1
            },
            {
              name: () => this.$tz("计费重,最大值"),
              key: "upper_threshold",
              component: "InputNumber",
              bind: {
                style: {
                  width: "100%"
                }
              },
              default: 0,
              show: ({ row }) => this.rows.data_type != 1
            },
            {
              name: () => this.$t("max_weight"),
              key: "first_weight",
              component: "InputNumber",
              bind: {
                style: {
                  width: "100%"
                }
              },
              default: 0
            },
            {
              name: () => this.$t("cost_t"),
              key: "fee_value",
              component: "InputNumber",
              bind: {
                style: {
                  width: "100%"
                }
              },
              default: 0
            },
            {
              key: "fee_vat_scale",
              name: () => this.$t("FreightVATRadio"),
              component: "InputNumber",
              placeholder: () => this.$t("enter") + this.$t("FreightVATRadio"),
              bind: {
                formatter: value => `${value}%`,
                parser: value => value.replace('%', ''),
                style: "width:100%",
                min: 0
              },
              default: 0
            },
            {
              key: "freight_rate",
              name: () => this.$t("freightRata"),
              component: "InputNumber",
              placeholder: () => this.$t("enter") + this.$t("freightRata"),
              bind: {
                formatter: value => `${value}%`,
                parser: value => value.replace('%', ''),
                style: "width:100%",
                min: 0
              },
              default: 0,
              show: ({ row }) => this.rows.collection_method == 1
            },
            {
              name: () => this.$t("start") + this.$t("time"),
              key: "start_day",
              placeholder: () =>
                this.$t("select") + this.$t("start") + this.$t("time"),
              component: "DatePicker",
              bind: {
                options: {
                  disabledDate() {
                    return false;
                  }
                }
              },
              methods: {
                format({ value }) {
                  return this.format.timeFormat(
                    value
                  );
                }
              }
            },
            {
              name: () => this.$t("end") + this.$t("time"),
              key: "end_day",
              placeholder: () =>
                this.$t("select") + this.$t("end") + this.$t("time"),
              component: "DatePicker",
              bind: {
                options: {
                  disabledDate() {
                    return false;
                  }
                }
              },
              methods: {
                format({ value }) {
                  return this.format.timeFormat(
                    value
                  );
                }
              }
            },
            {
              name: () => this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              bind: {
                type: "textarea",
                rows: 3
              },
              placeholder: () => this.$t("enter") + this.$t("Remarks")
            }
          ]
        }
      },
      footer: { show: () => true },
      header: {
        config: {
          custom: false
        },
        searchs: [
          // {
          //   key: "client_id",
          //   placeholder() {
          //     return this.$t("select") + this.$t("clientName");
          //   },
          //   component: "Select",
          //   options: [],
          //   config: {
          //     label: "account",
          //     value: "id"
          //   }
          // },
          // {
          //   name: () => this.$t("from_country"),
          //   key: "from_country",
          //   component: "Select",
          //   placeholder: () => this.$t("select") + this.$t("from_country"),
          //   options: [],
          //   config: {
          //     label({ row }) {
          //       return row.cn_title + "(" + row.code + ")";
          //     },
          //     value: "code"
          //   }
          // },
          // {
          //   name: () => this.$t("target_country"),
          //   key: "to_country",
          //   component: "Select",
          //   placeholder: () => this.$t("select") + this.$t("target_country"),
          //   options: [],
          //   config: {
          //     label({ row }) {
          //       return row.cn_title + "(" + row.code + ")";
          //     },
          //     value: "code"
          //   }
          // },
          // {
          //   key: "keywords",
          //   placeholder() {
          //     return this.$t("keyword");
          //   },
          //   component: "Input"
          // }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning"
              }
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            },
            // {
            //   name: this.$t("delete"),
            //   type: "delete",
            //   fnName: "delete",
            // 	bind: {
            // 	  type: "error"
            // 	},
            // 	disabled() {
            // 	  return !this.selectAll.length;
            // 	},
            // }
          ],
          methods: {
            export() {
              this.exportExc();
            },
            add() {
              console.log(this.config.rows);
              this.getModal("add").open({ config_id: this.config.rows.id });
            },
            delete() {
              let ids = this.selectAll.map(t => t.id)
              this.$Modal.confirm({
                title: this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("batchDel", { ids }).then(res => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg
                    });
                    this.getList();
                  });
                }
              });
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          width: 60,
          fixed: "left"
        },
        {
          name: () => this.$t("operate"),
          key: "operator_name",
          align: "left",
          minWidth: 100
        },

        {
          name: () => this.$t("minimum"),
          key: "lower_threshold",
          width: 80,
          show: ({ row }) => this.rows.data_type != 1

        },
        {
          name: () => this.$t("maximum"),
          key: "upper_threshold",
          width: 80,
          show: ({ row }) => this.rows.data_type != 1
        },
        {
          name: () => this.$t("expType"),
          key: "collection_method",
          width: 80,
          options: this.selectData.collection_method,
          methods: {
            render: ({ value, field }) => {
              if (!this.selectData.collection_method) {
                this.selectData.collection_method = [
                  { label: this.$t('freightRata'), value: 1 },
                  { label: this.$t('Fixed amount per ticket'), value: 2 }
                ]
              }
              let item = this.selectData.collection_method.find(t => t.value == value)
              return item ? item.label : '-'
            }
          }
        },
        {
          name: () => this.$t("Fixed amount per ticket"),
          key: "every_amount",
          width: 80
        },
        {
          name: () => this.$t("Fixed amount currency per ticket"),
          key: "every_amount_currency",
          width: 80
        },
        {
          name: () => this.$t("freightRata"),
          key: "freight_rate",
          width: 80,
          methods: {
            render: ({ value }) => value + '%'
          }
        },
        {
          name: () => this.$t("FreightVATRadio"),
          key: "fee_vat_scale",
          width: 80,
          methods: {
            render: ({ value }) => value + '%'
          }
        },
        {
          name: () => this.$t("start") + this.$t("time"),
          key: "start_time",
          width: 150
        },
        {
          name: () => this.$t("end") + this.$t("time"),
          key: "end_time",
          width: 150
        },
        {
          name: () => this.$t("Remarks"),
          key: "remarks",
          minWidth: 120
        },
        {
          name: () => this.$t("operation"),
          type: "btns",
          width: 120,
          fixed: "right",
          list: [
            {
              name: this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success"
              }
            },
            {
              name: this.$t("delete"),
              type: "delete",
              fnName: "delete"
            }
          ],
          methods: {
            update({ row }) {
              this.handleRequestMethods("detail", row.id).then(res => {
                this.getModal("add").open(res.payload, function () {
                  this.setTitle(this.$t("update"));
                });
              });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("del", row.id).then(res => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg
                    });
                    this.getList();
                  });
                }
              });
            }
          }
        }
      ]
    };
  }
};
</script>
